// extracted by mini-css-extract-plugin
module.exports = {"label":"StatusFilter_label__2Bf_L"};